/**
 * @fileoverview gRPC-Web generated client stub for accountpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_type_date_pb = require('../../google/type/date_pb.js')

var proto_accountpb_owner_pb = require('../../proto/accountpb/owner_pb.js')

var proto_accountpb_address_pb = require('../../proto/accountpb/address_pb.js')

var proto_accountpb_contactinfo_pb = require('../../proto/accountpb/contactinfo_pb.js')

var proto_accountpb_identification_pb = require('../../proto/accountpb/identification_pb.js')

var proto_accountpb_note_pb = require('../../proto/accountpb/note_pb.js')

var proto_accountpb_subaccount_pb = require('../../proto/accountpb/subaccount_pb.js')

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')
const proto = {};
proto.accountpb = require('./client_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.ClientServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.ClientServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ReadClientRequest,
 *   !proto.accountpb.ReadClientResponse>}
 */
const methodDescriptor_ClientService_ReadClient = new grpc.web.MethodDescriptor(
  '/accountpb.ClientService/ReadClient',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ReadClientRequest,
  proto.accountpb.ReadClientResponse,
  /**
   * @param {!proto.accountpb.ReadClientRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadClientResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.ReadClientRequest,
 *   !proto.accountpb.ReadClientResponse>}
 */
const methodInfo_ClientService_ReadClient = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.ReadClientResponse,
  /**
   * @param {!proto.accountpb.ReadClientRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadClientResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ReadClientRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.ReadClientResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ReadClientResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ClientServiceClient.prototype.readClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ClientService/ReadClient',
      request,
      metadata || {},
      methodDescriptor_ClientService_ReadClient,
      callback);
};


/**
 * @param {!proto.accountpb.ReadClientRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ReadClientResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ClientServicePromiseClient.prototype.readClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ClientService/ReadClient',
      request,
      metadata || {},
      methodDescriptor_ClientService_ReadClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ReadClientByUserRequest,
 *   !proto.accountpb.ReadClientResponse>}
 */
const methodDescriptor_ClientService_GetAccessibleClient = new grpc.web.MethodDescriptor(
  '/accountpb.ClientService/GetAccessibleClient',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ReadClientByUserRequest,
  proto.accountpb.ReadClientResponse,
  /**
   * @param {!proto.accountpb.ReadClientByUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadClientResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.ReadClientByUserRequest,
 *   !proto.accountpb.ReadClientResponse>}
 */
const methodInfo_ClientService_GetAccessibleClient = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.ReadClientResponse,
  /**
   * @param {!proto.accountpb.ReadClientByUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadClientResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ReadClientByUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.ReadClientResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ReadClientResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ClientServiceClient.prototype.getAccessibleClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ClientService/GetAccessibleClient',
      request,
      metadata || {},
      methodDescriptor_ClientService_GetAccessibleClient,
      callback);
};


/**
 * @param {!proto.accountpb.ReadClientByUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ReadClientResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ClientServicePromiseClient.prototype.getAccessibleClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ClientService/GetAccessibleClient',
      request,
      metadata || {},
      methodDescriptor_ClientService_GetAccessibleClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.Client,
 *   !proto.accountpb.UpdateClientResponse>}
 */
const methodDescriptor_ClientService_UpdateClient = new grpc.web.MethodDescriptor(
  '/accountpb.ClientService/UpdateClient',
  grpc.web.MethodType.UNARY,
  proto.accountpb.Client,
  proto.accountpb.UpdateClientResponse,
  /**
   * @param {!proto.accountpb.Client} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.UpdateClientResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.Client,
 *   !proto.accountpb.UpdateClientResponse>}
 */
const methodInfo_ClientService_UpdateClient = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.UpdateClientResponse,
  /**
   * @param {!proto.accountpb.Client} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.UpdateClientResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.Client} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.UpdateClientResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.UpdateClientResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ClientServiceClient.prototype.updateClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ClientService/UpdateClient',
      request,
      metadata || {},
      methodDescriptor_ClientService_UpdateClient,
      callback);
};


/**
 * @param {!proto.accountpb.Client} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.UpdateClientResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ClientServicePromiseClient.prototype.updateClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ClientService/UpdateClient',
      request,
      metadata || {},
      methodDescriptor_ClientService_UpdateClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ListClientRequest,
 *   !proto.accountpb.ListClientResponse>}
 */
const methodDescriptor_ClientService_ListClient = new grpc.web.MethodDescriptor(
  '/accountpb.ClientService/ListClient',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ListClientRequest,
  proto.accountpb.ListClientResponse,
  /**
   * @param {!proto.accountpb.ListClientRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListClientResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.ListClientRequest,
 *   !proto.accountpb.ListClientResponse>}
 */
const methodInfo_ClientService_ListClient = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.ListClientResponse,
  /**
   * @param {!proto.accountpb.ListClientRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListClientResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ListClientRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.ListClientResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ListClientResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ClientServiceClient.prototype.listClient =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ClientService/ListClient',
      request,
      metadata || {},
      methodDescriptor_ClientService_ListClient,
      callback);
};


/**
 * @param {!proto.accountpb.ListClientRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ListClientResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ClientServicePromiseClient.prototype.listClient =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ClientService/ListClient',
      request,
      metadata || {},
      methodDescriptor_ClientService_ListClient);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.EmptyRequest,
 *   !proto.accountpb.ListSelectionItemResponse>}
 */
const methodDescriptor_ClientService_ListAccountType = new grpc.web.MethodDescriptor(
  '/accountpb.ClientService/ListAccountType',
  grpc.web.MethodType.UNARY,
  proto.accountpb.EmptyRequest,
  proto.accountpb.ListSelectionItemResponse,
  /**
   * @param {!proto.accountpb.EmptyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListSelectionItemResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.EmptyRequest,
 *   !proto.accountpb.ListSelectionItemResponse>}
 */
const methodInfo_ClientService_ListAccountType = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.ListSelectionItemResponse,
  /**
   * @param {!proto.accountpb.EmptyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListSelectionItemResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.EmptyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.ListSelectionItemResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ListSelectionItemResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ClientServiceClient.prototype.listAccountType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ClientService/ListAccountType',
      request,
      metadata || {},
      methodDescriptor_ClientService_ListAccountType,
      callback);
};


/**
 * @param {!proto.accountpb.EmptyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ListSelectionItemResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ClientServicePromiseClient.prototype.listAccountType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ClientService/ListAccountType',
      request,
      metadata || {},
      methodDescriptor_ClientService_ListAccountType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ListSubAccountTypeItemRequest,
 *   !proto.accountpb.ListSelectionItemResponse>}
 */
const methodDescriptor_ClientService_ListSubAccountType = new grpc.web.MethodDescriptor(
  '/accountpb.ClientService/ListSubAccountType',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ListSubAccountTypeItemRequest,
  proto.accountpb.ListSelectionItemResponse,
  /**
   * @param {!proto.accountpb.ListSubAccountTypeItemRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListSelectionItemResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.ListSubAccountTypeItemRequest,
 *   !proto.accountpb.ListSelectionItemResponse>}
 */
const methodInfo_ClientService_ListSubAccountType = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.ListSelectionItemResponse,
  /**
   * @param {!proto.accountpb.ListSubAccountTypeItemRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListSelectionItemResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ListSubAccountTypeItemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.ListSelectionItemResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ListSelectionItemResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ClientServiceClient.prototype.listSubAccountType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ClientService/ListSubAccountType',
      request,
      metadata || {},
      methodDescriptor_ClientService_ListSubAccountType,
      callback);
};


/**
 * @param {!proto.accountpb.ListSubAccountTypeItemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ListSelectionItemResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ClientServicePromiseClient.prototype.listSubAccountType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ClientService/ListSubAccountType',
      request,
      metadata || {},
      methodDescriptor_ClientService_ListSubAccountType);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.GetAccountInfoRequest,
 *   !proto.accountpb.GetAccountInfoResponse>}
 */
const methodDescriptor_ClientService_GetAccountInfo = new grpc.web.MethodDescriptor(
  '/accountpb.ClientService/GetAccountInfo',
  grpc.web.MethodType.UNARY,
  proto.accountpb.GetAccountInfoRequest,
  proto.accountpb.GetAccountInfoResponse,
  /**
   * @param {!proto.accountpb.GetAccountInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.GetAccountInfoResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.GetAccountInfoRequest,
 *   !proto.accountpb.GetAccountInfoResponse>}
 */
const methodInfo_ClientService_GetAccountInfo = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.GetAccountInfoResponse,
  /**
   * @param {!proto.accountpb.GetAccountInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.GetAccountInfoResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.GetAccountInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.GetAccountInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.GetAccountInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ClientServiceClient.prototype.getAccountInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ClientService/GetAccountInfo',
      request,
      metadata || {},
      methodDescriptor_ClientService_GetAccountInfo,
      callback);
};


/**
 * @param {!proto.accountpb.GetAccountInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.GetAccountInfoResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ClientServicePromiseClient.prototype.getAccountInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ClientService/GetAccountInfo',
      request,
      metadata || {},
      methodDescriptor_ClientService_GetAccountInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.GetUserAccountIdRequest,
 *   !proto.accountpb.GetAccountIdResponse>}
 */
const methodDescriptor_ClientService_GetUserAccountId = new grpc.web.MethodDescriptor(
  '/accountpb.ClientService/GetUserAccountId',
  grpc.web.MethodType.UNARY,
  proto.accountpb.GetUserAccountIdRequest,
  proto.accountpb.GetAccountIdResponse,
  /**
   * @param {!proto.accountpb.GetUserAccountIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.GetAccountIdResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.GetUserAccountIdRequest,
 *   !proto.accountpb.GetAccountIdResponse>}
 */
const methodInfo_ClientService_GetUserAccountId = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.GetAccountIdResponse,
  /**
   * @param {!proto.accountpb.GetUserAccountIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.GetAccountIdResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.GetUserAccountIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.GetAccountIdResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.GetAccountIdResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.ClientServiceClient.prototype.getUserAccountId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.ClientService/GetUserAccountId',
      request,
      metadata || {},
      methodDescriptor_ClientService_GetUserAccountId,
      callback);
};


/**
 * @param {!proto.accountpb.GetUserAccountIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.GetAccountIdResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.ClientServicePromiseClient.prototype.getUserAccountId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.ClientService/GetUserAccountId',
      request,
      metadata || {},
      methodDescriptor_ClientService_GetUserAccountId);
};


module.exports = proto.accountpb;

